import flatpickr from "flatpickr"
import { French } from "flatpickr/dist/l10n/fr.js"
import { German } from "flatpickr/dist/l10n/de.js"
import rangePlugin from "flatpickr/dist/plugins/rangePlugin"
import breakpoints from '../../utils/breakpoints'

class FlatpickrInit {
    constructor() {
        this.customFlatpickrs = [...document.querySelectorAll('[data-flatpickr]')]
        this.lang = document.documentElement.lang || "en"
        this.locales = {
            'fr-CH': French,
            'de-CH': German,
            'en': 'en'
        }

        for (let customFlatpickr of this.customFlatpickrs) {
            let additionalConfig = {}

            try {
                const flatpickrDataset = customFlatpickr.dataset.flatpickr
                if (flatpickrDataset) {
                    additionalConfig = JSON.parse(flatpickrDataset)
                }
            } catch (error) {
                console.log('error while decoding flatpickr config')
            }

            // add range plugin 
            /*
            if (additionalConfig.rangePlugin) {
                additionalConfig = {
                    ...additionalConfig,
                    plugins: [
                        new rangePlugin({ input: additionalConfig.rangePlugin })
                    ]
                }
            }
            */

            const positionElement = customFlatpickr.closest('.controls')
            let isStatic = false
            if (positionElement && window.innerWidth >= breakpoints.large) {
                isStatic = true
            }

            const flatpickrConfig = {
                static: isStatic,
                dateFormat: "d.m.Y",
                timeFormat: "H:i",
                disableMobile: "true",
                // includeDat: true,
                // positionElement: positionElement,
                getIsDate: true,
                locale: {
                    ...this.locales[this.lang],
                    firstDayOfWeek: 1
                },
                ...additionalConfig
            }

            const fp = flatpickr(customFlatpickr, flatpickrConfig)



        }
    }
}

export default FlatpickrInit


